// imports
import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../..';
import { msgFromError } from '../../utils';
import { TEXTS } from '../../../../constants';
import { parseQuests } from './quests/helper';
import { World, Trait, BackpackItem } from '../../../../common/types';
import { IAPIQuests, config as CONFIG_API, quests as QUEST_API } from '../../../api';

// exports
export const fetchConfig = createAsyncThunk(
  'config/fetch',
  (_, { rejectWithValue }) => {
    let availableSideQuests: IAPIQuests = {};
    return QUEST_API.fetchAvailable()
      .then((availableQuests) => {
        availableSideQuests = availableQuests;
        return CONFIG_API.fetch();
      }).then((config) => {
        const sideQuests = parseQuests(availableSideQuests);
        const campaignQuests = parseQuests(config.campaignQuests, true);
        return {
          world: config.world as World,
          quests: { ...sideQuests, ...campaignQuests },
          traits: config.traits as { [key: string]: Trait },
          items: config.items as { [key: string]: BackpackItem },
          genericTexts: config.genericTexts as { [key: string]: { title: string; body: string } }
        };
      }).catch((error) => rejectWithValue(msgFromError(error, TEXTS.ERROR_FETCH_CONFIG)));
  },
  {
    condition: (_, { getState }) => {
      const { fetchStatus } = (getState() as RootState).config;
      return fetchStatus !== 'loading';
    }
  }
);

export default { fetchConfig };
